<template>
  <v-card class="collectionDetail">
    <v-card-title>
      <h2>{{ pageTitle }}</h2>
      <br/>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>Name: {{name}}</v-list-item-subtitle>
          <v-list-item-subtitle>Description: {{description}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="purchaseOrder_headers"
            :items="items"
            hide-default-footer
          >
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <div class="row">
        <div class="col d-flex justify-end">
          <div class="col d-flex justify-start">
            <v-btn class="" @click="onBackToFulfillment" id="btnBack">Back</v-btn>
          </div>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import moment from "moment";
import lodash from "lodash";
import * as api from "@/api";
export default {
  components: {
    Notification,
    Pagination
  },
  data() {
    return {
      purchaseOrder_headers: [
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "Author Name",
          align: "start",
          sortable: false,
          value: "AuthorName"
        },
        {
          text: "Publisher Name",
          align: "start",
          sortable: false,
          value: "PublisherName"
        }
      ],
      items: [],
      name: null,
      description:null,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      parentPage: null,
      pageTitle: ""
    };
  },
  methods: {
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      console.log(this.paging);

      this.getItemDetails(this.$route.params.id);
    },
    getItemDetails(id) {
      let that = this;
      let url = "organization-collection/collection/publication"
      that.items.splice(0, that.items.length);
      new Promise((resolve, reject) => {
        api
          .getByPaginById(url,id, this.paging)
          .then(response => {
            this.paging.count = response.data.count;
            if (
              response.data != null &&
              response.data.data != null &&
              response.data.data.length > 0
            ) {
              response.data.data.forEach(e => {
                that.items.push(e);
              });
            } else {
              console.warn("No Collection Details found");
              console.warn(response.data.data);
            }
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    onBackToFulfillment() {
      debugger
        this.$router.push({
          name: "OrgCollections",
          params: { page: this.parentPage }
        });
    }
  },
  mounted() {
    debugger
    console.log("id param value...");
    console.log(this.$route.params);
    this.parentPage = this.$route.params.page;
    this.pageTitle = "Collection Details";
    this.name = this.$route.params.name;
    this.description = this.$route.params.description;
    this.getItemDetails(this.$route.params.id);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgCollectionDetails.vue